import { JourneyService } from '@app/core/services/financial-engine/journey.service';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccessMedia } from '@app/core/models/models';
import { switchMap, takeUntil, tap } from 'rxjs/operators';
import { AbstractOnDestroyComponent } from '@app/core/abstract-on-destroy-component/abstract-on-destroy-component';
import { Observable } from 'rxjs';
import { Page } from '@app/core/models/page';
import { Pagination } from '@app/core/models/pagination';
import { environment } from '@env/environment';
import { PageTitleService } from '@app/core/services/shared/page-title.service';
import { AccessMediaFilterComponent } from '@app/shared/components/access-media-filter/access-media-filter.component';
import { JourneyPortal } from '@app/core/models/journey/journey-portal';

@Component({
  selector: 'app-activity-list',
  templateUrl: './activity-list.component.html',
  styleUrls: ['./activity-list.component.css'],
  host: {
    class: 'main-container'
  }
})
export class ActivityListComponent extends AbstractOnDestroyComponent implements OnInit, AfterViewInit {

  @ViewChild(AccessMediaFilterComponent) accessMediaFilter;

  journeys: Array<JourneyPortal> = [];
  accessMedias: Array<any>;
  filter;

  period: any = {};
  pagination: Pagination = {
    totalElements: 0,
    elements: environment.passenger.application.pageSize,
    totalPages: 0,
    page: 0
  };
  tapTypes: string[] = environment.passenger.journeys.allowedTypes;

  loading = false;

  noAccessMediaMessage: string;
  addAccessMediaMessage: string;
  messagesLoaded = false;


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private journeyService: JourneyService,
    private pageTitleService: PageTitleService) {
      super();
      this.filter = {
        accessMedias: [],
        selectedAccessRef: '',
        month: '',
        date: Date,
        period: { beginDate: null, endDate: null },
        display: false
      };
      this.period = {};
  }

  ngOnInit() {
    this.pageTitleService.setTitle('NAVBAR.ACTIVITIES');
    this.route.data.subscribe((data: { accessmedias: Page<AccessMedia> }) => {
      this.accessMedias = this.filter.accessMedias = data.accessmedias.content
        .filter(access => access.accessMediaReference)
        .map(accessMedia => ({...accessMedia, selected: true}));
      this.displayAll();
    });
  }

  ngAfterViewInit() {
    if (this.accessMediaFilter?.filterEvent) {
      this.accessMediaFilter.filterEvent.pipe(
        switchMap((filter: any) => {
          this.filter.accessMedias = filter.accessMedias;
          this.period = filter.period;
          this.journeys = [];

          return this.loadJourneys$();
        })
      ).subscribe(result => {
        this.journeys = [...this.journeys].concat(result.content);
        this.pagination.totalPages = result.totalPages;
      });
    }
  }

  private loadJourneys$(): Observable<Page<JourneyPortal>> {
    const tokens = this.filter.accessMedias
      .filter(_a => _a.tokens && _a.selected).map(_a => _a.tokens.map(token => token.accessMediaToken)).reduce((acc, val) => acc.concat(val), []);
    this.loading = true;
    return this.journeyService.getJourneys(tokens, this.tapTypes,
      this.period.beginDate, this.period.endDate, this.pagination.page, this.pagination.elements).pipe(
        tap(() => { this.loading = false; })
      );
  }

  private loadJourneys() {
    this.loadJourneys$()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(result => {
        this.journeys = [...this.journeys].concat(result.content);
        this.pagination.totalPages = result.totalPages;
      });
  }

  displayAll() {
    this.filter.display = false;
    this.accessMedias.forEach(accessMedia => accessMedia.selected = true);
    this.filter.accessMedias = this.accessMedias;
    this.period = {};
    this.journeys = [];
    this.loadJourneys();
  }

  displayFilter() {
    this.filter.display = true;
  }

  enrolementSupport() {
    this.router.navigate([`supports/${environment.merchantMode}`, 'enrolement']);
  }

  loadMoreJourneys() {
    if (this.pagination.page + 1 < this.pagination.totalPages) {
      this.pagination.page++;
      this.loadJourneys();
    }
  }
}
